const portal_url = "https://dev-portal.gps.id/backend";
const base_url = "https://dev-seen.gps.id/backend";

export { portal_url, base_url };
